import { BASE_URL } from '../../config'
import { SET_ERROR_STATE, RESET_STATUS_STATE, REQUEST_STATE, SET_SUCCESS_STATE} from '../../utils/constants/actionTypes';
import {SResendVerificationEm} from '../../config/api'

export default ( data ) => async (dispatch) => {
	dispatch({ type: RESET_STATUS_STATE});
	dispatch({ type : REQUEST_STATE });
	
	try{
		let res = await fetch(`${BASE_URL}${SResendVerificationEm}`, {
					method : 'POST',
					credentials: 'include',
					headers : { 'Content-Type' : "application/json", },
					body: JSON.stringify({
                        borrower : {
                            email : data
                        }
                    })
				})

		let hasil = await res.json()
		if( res.status === 200 ){
			dispatch({ type: SET_SUCCESS_STATE, payload : hasil.status.message })
		} else{
			dispatch({ type: SET_ERROR_STATE, payload : hasil.status.message })
		}
	} catch(err){
		dispatch({ type: SET_ERROR_STATE, payload : err.message })
	}
}